/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { Flex, Heading, Button, Checkbox } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import FormInput from "../../../components/forms/form-Input";
import { useLookupCurrencyMultiples } from "../../../services/lookups-mutations";
import {
  DENOMINATION_SHAPE,
  servicesDenominationDefault,
  offeredServicesDefault,
  SERVICES_NAME,
} from "../constants";
import CassettesForm from "components/common/cassettes";

export default function OfferedServices({
  onNextStep,
  onPrevStep,
  services,
  currencies,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [currentEditingDenomination, setCurrentEditingDenomination] =
    useState(null);

  const {
    mutate: getDenominationMultiples,
    data: denominationMultipleList,
    // isPending: gettingDenominationMultiple,
    // error: denominationMultipleError,
    reset: resetDenominationMultiple,
  } = useLookupCurrencyMultiples();

  const {
    handleSubmit,
    control,
    getValues,
    reset,
    setError,
    watch,
    clearErrors,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: { ...offeredServicesDefault, services: [...services] },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    serviceName: { required: "Please Enter Service Name" },
    cassetteCurrency: { required: "Please Select Currency" },
    cassetteMultiple: { required: "Please Select Multiple" },
    cassetteType: { required: "Please Select Cassette Type" },
    maker: { required: "Please Select Maker" },
    limit: { required: "Please Enter Limit" },
  };

  const {
    fields: servicesFields,
    remove: servicesRemove,
    update: servicesUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "services",
  });
  const { fields: cassettesFields } = useFieldArray({
    control: generalFieldProps.control,
    name: "cassettes",
  });
  const { fields: denominationsFields, remove: denominationRemove } =
    useFieldArray({
      control: generalFieldProps.control,
      name: "denominations",
    });

  useEffect(() => {
    if (addData) addData([...servicesFields]);
  }, [watch("services")]);
  useEffect(() => {
    const currency = watch("denominationCurrency");
    resetDenominationMultiple();
    if (currency) {
      getDenominationMultiples(currency.shortName);
    }
  }, [watch("denominationCurrency")]);

  const submitInfo = (data) => {
    const _services = [...servicesFields];
    const _newItem = {
      serviceName: data.serviceName,
      cassettes: data.cassettes,
      denominations: data.denominations,
      expanded: false,
    };
    if (currentEditing !== null) {
      _services[currentEditing] = _newItem;
      setCurrentEditing(null);
    } else {
      _services.push(_newItem);
    }
    reset({ ...offeredServicesDefault, services: _services });
  };

  const addDenomination = () => {
    const _data = getValues();
    const _denomination = [...denominationsFields];
    let isDataValid = true;
    clearErrors([
      "denominationCurrency",
      "denominationMultiple",
      "shape",
      "version",
    ]);
    if (!_data.denominationCurrency) {
      setError("denominationCurrency", {
        type: "required",
        message: "Please Select Currency",
      });
      isDataValid = false;
    }
    if (!_data.denominationMultiple) {
      setError("denominationMultiple", {
        type: "required",
        message: "Please Select Multiple",
      });
      isDataValid = false;
    }
    if (!_data.shape) {
      setError("shape", { type: "required", message: "Please Select Shape" });
      isDataValid = false;
    }
    if (!isDataValid) return;
    const _newItem = {
      denominationCurrency: _data.denominationCurrency,
      denominationMultiple: _data.denominationMultiple,
      shape: _data.shape,
      version: _data.version,
    };
    if (currentEditingDenomination !== null) {
      _denomination[currentEditingDenomination] = _newItem;
      setCurrentEditingDenomination(null);
    } else {
      _denomination.push(_newItem);
    }

    reset({
      ..._data,
      ...servicesDenominationDefault,
      denominations: _denomination,
    });
  };

  const cancelDenominationEditing = () => {
    const _data = getValues();
    reset({ ..._data, ...servicesDenominationDefault });
    setCurrentEditingDenomination(null);
  };

  const cancelEditing = () => {
    reset({ ...offeredServicesDefault, services: [...servicesFields] });
    setCurrentEditing(null);
  };

  const editDenominationCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            const _data = getValues();
            reset({ ..._data, ...dataItem });
            setCurrentEditingDenomination(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteDenominationCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete  "
          cursor="pointer"
          onClick={() => {
            denominationRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({
              ...offeredServicesDefault,
              ...dataItem,
              services: [...servicesFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete"
          cursor="pointer"
          onClick={() => {
            servicesRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };
  const expandChange = ({ dataIndex }) => {
    const _services = [...servicesFields];
    _services[dataIndex].expanded = !_services[dataIndex].expanded;
    servicesUpdate(dataIndex, _services[dataIndex]);
  };
  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Cassettes
        </Heading>
        <Grid data={dataItem.cassettes}>
          <GridColumn field="description" title="Description" />
          <GridColumn
            field="Denomination"
            cell={({ dataItem }) => (
              <td>
                {dataItem.cassetteCurrency.shortName}&nbsp;
                {dataItem.cassetteMultiple.text}
              </td>
            )}
          />
          <GridColumn title="Cassette type" field="cassetteType.text" />
          <GridColumn title="Maker" field="maker" />
          <GridColumn title="Limit" field="limit" />
          <GridColumn
            title="Dual Scanning"
            cell={({ dataItem }) => (
              <td>
                <Checkbox isChecked={dataItem.dualScanning} />
              </td>
            )}
          />
        </Grid>
        <Heading
          style={{
            width: "100%",
            fontSize: "14px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Denomination
        </Heading>
        <Grid data={dataItem.denominations}>
          <GridColumn
            title="Currency"
            cell={({ dataItem }) => (
              <td>{dataItem.denominationCurrency.shortName}</td>
            )}
          />
          <GridColumn
            title="Multiple"
            cell={({ dataItem }) => (
              <td>{dataItem.denominationMultiple.text}</td>
            )}
          />

          <GridColumn title="Shape" field="shape.text" />
          <GridColumn title="Version" field="version" />
        </Grid>
      </>
    );
  }
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Offered Services</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex w="100%" justify="flex-end" flexDirection="row" gap="16px">
            <Button
              type="button"
              onClick={() => onPrevStep([...servicesFields])}
            >
              Back
            </Button>
            <Button
              type="button"
              onClick={() => onNextStep([...servicesFields])}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Service Name"
        name="serviceName"
        id="id"
        text="text"
        data={SERVICES_NAME}
        placeholder="Select Service Name"
        rules={formValidationRules.serviceName}
        dropdownProps={{ filterable: false }}
      />
      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Cassettes
      </Heading>
      <CassettesForm
        key={cassettesFields.length}
        addData={(data) => {
          setValue("cassettes", [...data]);
        }}
        cassettes={cassettesFields}
        currencies={currencies}
      />
      <Heading
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      >
        Denominations
      </Heading>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Currency"
        name="denominationCurrency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        // rules={formValidationRules.currency}
        onChange={() => {
          setValue("denominationMultiple", "");
        }}
        dropdownProps={{ filterable: true }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Multiples"
        name="denominationMultiple"
        id="id"
        text="text"
        data={
          denominationMultipleList
            ? denominationMultipleList?.data.map((elm) => ({
                id: elm.multiple,
                text: elm.multiple,
              }))
            : []
        }
        placeholder="Select Multiple"
        // rules={formValidationRules.multiple}
        disabled={!watch("denominationCurrency")}
        dropdownProps={{ filterable: true }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Shape"
        name="shape"
        id="id"
        text="text"
        data={DENOMINATION_SHAPE || []}
        placeholder="Select Shape"
        // rules={formValidationRules.currency}
        dropdownProps={{ filterable: false }}
      />
      <FormInput
        {...generalFieldProps}
        // isRequired={true}
        label="Version"
        // rules={formValidationRules.description}
        name="version"
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditingDenomination !== null ? (
          <Button type="button" onClick={cancelDenominationEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="button" onClick={addDenomination}>
          {currentEditingDenomination !== null
            ? "Update Denomination"
            : "Add Denomination"}
        </Button>
      </div>
      <Grid data={denominationsFields}>
        <GridColumn title="Currency" field="denominationCurrency.shortName" />
        <GridColumn title="Multiple" field="denominationMultiple.text" />

        <GridColumn title="Shape" field="shape.text" />
        <GridColumn title="Version" field="version" />
        <GridColumn title="Edit" width={100} cell={editDenominationCell} />
        <GridColumn title="Delete" width={100} cell={deleteDenominationCell} />
      </Grid>
      <div
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button type="button" onClick={cancelEditing}>
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update Service" : "Add Service"}
        </Button>
      </div>
      <Grid
        data={servicesFields}
        detail={DetailComponent}
        expandField="expanded"
        onExpandChange={expandChange}
      >
        <GridColumn field="serviceName.id" title="Service Name" />
        <GridColumn title="Edit" width={100} cell={editCell} />
        <GridColumn title="Delete" width={100} cell={deleteCell} />
      </Grid>
    </form>
  );
}
